import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { StudentClassroomShowdata } from '../../services/LoginPageService';

const StudentAddDevice = () => {
    const [deviceId,setDeviceId]=useState('');
    const [studentClassroom,setStudentClassroom]=useState('');
    const [studentClassroomList,setStudentClassroomList]=useState([]);
    
    const onClassroomChange=(e)=>{
        setStudentClassroom(e.target.value);
    }

    useEffect(()=>{
        StudentClassroomShowdata(handleStudentClassroom,handleStudentClassroomException);
    },[])

    const handleStudentClassroom=(dataObject)=>{
        setStudentClassroomList(dataObject?.data);
        console.log(dataObject?.data);
    }
    
    const handleStudentClassroomException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    return (
        <div>
            <form>
                <Grid container spacing={2} style={{display:'flex'}}>
                    <Grid container item xs={8} sm={8} md={8} lg={8} xl={8} style={{border:'solid',borderColor:'whitesmoke',marginTop:'30px',marginLeft:'70px',height:'60vh',width:'70%'}}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{alignSelf:'center', textAlign:'center'}}>
                            <h2>Add Device</h2>
                            <hr />
                        </Grid>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11} >
                                <TextField
                                    fullWidth 
                                    label="Device Id"
                                    placeholder='Device Id'
                                    variant="outlined"
                                    required
                                    onChange={(e) => { setDeviceId(e.target.value) }}
                                    value={deviceId}
                                />
                            </Grid>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Classroom</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Classroom"
                                    placeholder='Select Classroom'
                                    required
                                    value={studentClassroom}
                                    onChange={(e) => onClassroomChange(e) }>
                                    {
                                        studentClassroomList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.classRoom}</MenuItem>
                                            )
                                        })
                                    }  
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={10} md={10} lg={10} xl={10} >
                                <Button style={{marginLeft:'10px'}} type="submit" variant="contained">Assign</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

export default StudentAddDevice
